import { css } from '@emotion/react';
import { lab2MapControlTheme } from 'styles/lab2MapTheme';

const {
    zoomBackground,
    zoomButtonBackground,
    zoomButtonColor,
    attributionBackground,
    popupBackground,
    popupBorder,
} = lab2MapControlTheme;

export const mainContainer = css`
    display: flex;
    flex: 1;
    height: 100%;
`;

export const mapArea = css`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;

    .ol-zoom {
        position: absolute;
        background-color: ${zoomBackground};
        border-radius: 4px;
        padding: 2px;
        top: 1em;
        right: 1em;
    }

    .ol-control button {
        display: flex;
        margin: 1px;
        font-size: 12px;
        font-weight: bold;
        justify-content: center;
        text-align: center;
        height: 16px;
        width: 16px;
        border: none;
        color: ${zoomButtonColor};
        background-color: ${zoomButtonBackground};
    }

    .ol-zoom-in {
        border-radius: 2px 2px 0px 0px;
    }

    .ol-zoom-out {
        border-radius: 0px 0px 2px 2px;
    }

    .ol-rotate {
        display: none;
    }

    .ol-attribution {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        align-items: center;
        position: absolute;

        font-size: 10px;
        background-color: ${attributionBackground};
        border-radius: 4px;
        padding: 2px 0px;
        bottom: 1em;
        right: 1em;
    }

    .ol-attribution button {
        display: flex;
        align-items: center;
        border-radius: 2px;
        background-color: #ffffff;
        cursor: pointer;
    }

    .ol-attribution ul {
        padding: 0px 5px;
    }

    .ol-attribution ul a {
        text-decoration: none;
        color: #000000;
    }

    .ol-attribution button[aria-expanded='false'] + ul {
        display: none;
    }

    .ol-popup {
        display: block;
        position: absolute;
        background-color: transparent;
        border: none;
        box-shadow: none;
        padding: 0;
        width: auto;
        height: auto;
    }
    .ol-popup:after,
    .ol-popup:before {
        display: none;
    }

    .map-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(6, 26, 51, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;
        pointer-events: none;
    }

    .map-loading-text {
        padding: 12px 18px;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.9);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.2px;
        color: #002755;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
    }
`;
